<!-- START Resident form -->

<form class="sidebar__form" [formGroup]="form">

	<h2 class="pax-title-h2">
		{{'bookingDetails.titles.residentFare' | ibeadmin:'sync'}}
	</h2>
	<p class="muted bottom-gap">
		{{'bookingDetails.label.residentFareInfo' | ibeadmin:'sync'}}
	</p>
						
	<div class="form--edit-mode">
		<div class="form-field--row grid no-padding">
			
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="resident--document_number">
					{{'bookingDetails.label.idDocumentNumber' | ibeadmin:'sync'}}
				</label>
				<input 
					class="input-text"
					formControlName="residentDocNumber" 
					aria-describedby="resident_document_number-error"
					id="resident--document_number" />
				<span 
					aria-live="polite" 
					class="input-error" 
					id="resident_document_number-error" 
					role="alert"
					[attr.aria-label]="formResidentErrors('residentDocNumber')"
					*ngIf="form.controls['residentDocNumber'].invalid && displayValidationMessages">
					{{ formResidentErrors('residentDocNumber') | ibeadmin:'sync' }}
				</span>
			</div>
			
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="resident--fiscal_number">
					{{'bookingDetails.label.fiscalNumber' | ibeadmin:'sync'}}
				</label>
				<input 
					class="input-text"
					formControlName="residentfiscalNumber" 
					aria-describedby="resident_fiscal_number-error"
					id="resident--fiscal_number" />
				<span 
					aria-live="polite" 
					class="input-error" 
					id="resident_fiscal_number-error" 
					role="alert"
					[attr.aria-label]="formResidentErrors('residentfiscalNumber')"
					*ngIf="form.controls['residentfiscalNumber'].invalid && displayValidationMessages">
					{{ formResidentErrors('residentfiscalNumber') | ibeadmin:'sync' }}
				</span>
			</div>
		</div>
		
		<hr class="separator">
	</div>
</form>	
		
<!-- END Resident form -->
